import { getFrameworkInfo } from "@/utils/framework-utils";
import { auth, FirebaseTimestamp } from "@/js/external-js/config/main_config";
import { acceptSuggestedTaskItem } from "@/services/aiSuggestionsService";
import { createTask } from "@/services/assuranceActionsService";
import { toast } from "sonner";

export const processAcceptedTask = async (taskData: { suggestionDocId: string; task: any }) => {
    if (!taskData) return;

    console.log('[DEBUG] Processing accepted task:', taskData);

    try {
        // Create AI crumb with the format: suggestionDocId_taskId
        const aiCrumb = `${taskData.suggestionDocId}_${taskData.task.originalId}`;

        // Get current timestamp for task creation
        const now = new Date();
        const nextCheckDate = new Date(now.getTime() + (Number(taskData.task.checkInterval || 365) * 24 * 60 * 60 * 1000));

        // Get framework info and control IDs using our shared utility
        const { name: frameworkName, controls } = getFrameworkInfo(taskData.task.isoClauses);

        // Structure the task data to match the expected format in createTask
        const taskPayload = {
            checkDetail: {
                active: 'true',
                assignedTo: taskData.task.assignee || auth.currentUser?.uid || '',
                check: taskData.task.description || 'AI Suggested Task',
                evidence: taskData.task.evidenceType || 'Upload Evidence',
                framework: {
                    '0': {
                        frameName: frameworkName,
                        controls: controls // Include the control IDs here
                    }
                },
                meetingNeeded: taskData.task.meetingRequired?.toString() || 'true',
                aiSuggestionSource: aiCrumb
            },
            checkFrequency: {
                checkDays: taskData.task.checkInterval?.toString() || '365',
                reminderDays: taskData.task.reminderDays?.toString() || '7',
                sendReminder: taskData.task.meetingRequired?.toString() || 'true',
                nextCheck: nextCheckDate,
                lastCheck: {}
            },
            checkHistory: {
                numberPreviousChecks: '0'
            },
            createdBy: auth.currentUser?.uid || '',
            createdAt: FirebaseTimestamp.now(),
            updatedAt: FirebaseTimestamp.now()
        };

        console.log('[DEBUG] Creating task with data:', taskPayload);
        const result = await createTask(taskPayload);

        if (result?.success && result?.id) {
            console.log('[DEBUG] Accepting AI suggestion:', taskData);
            // Extract the baseId from the combined task.id (format: suggestionId_baseId)
            const baseId = taskData.task.originalId;
            console.log('[DEBUG] Using baseId for acceptance:', baseId);
            await acceptSuggestedTaskItem(taskData.suggestionDocId, baseId);
            toast.success('AI suggestion accepted and task created');
            return true;
        } else {
            toast.error('Failed to create task');
            return false;
        }
    } catch (error) {
        console.error('[DEBUG] Error processing accepted task:', error);
        toast.error('Failed to process accepted task');
        return false;
    }
};

export default processAcceptedTask;
